import React, { useState, useEffect } from 'react';
import { getAuthor } from '../services/api';
import { MapPin, Mail } from 'lucide-react';

const About = () => {
  const [authorInfo, setAuthorInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuthor = async () => {
      try {
        const data = await getAuthor();
        setAuthorInfo(data);
      } catch (error) {
        console.error('Error fetching author info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAuthor();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  if (!authorInfo) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Author information not available.</p>
      </div>
    );
  }
  return (
    <div className="py-16 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-16 text-center">
          <h1 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6">About</h1>
        </div>

        <div className="mb-12">
          <div className="mb-8">
            {authorInfo.bio.split('\n\n').map((paragraph, index) => (
              <p key={index} className="text-gray-700 leading-relaxed mb-6 text-lg">
                {paragraph.trim()}
              </p>
            ))}
          </div>

          <div className="flex flex-col gap-4 pt-8 border-t border-gray-200">
            <div className="flex items-center gap-3 text-gray-600">
              <MapPin size={18} />
              <span>{authorInfo.location}</span>
            </div>
            <div className="flex items-center gap-3 text-gray-600">
              <Mail size={18} />
              <a
                href={`mailto:${authorInfo.email}`}
                className="hover:text-gray-900 transition-colors duration-200"
              >
                {authorInfo.email}
              </a>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-8 border border-gray-200">
          <h2 className="text-2xl font-serif text-gray-900 mb-6">Writing Philosophy</h2>
          <div className="space-y-4 text-gray-700">
            <p className="leading-relaxed">
              I believe in slow writing over content creation, in depth over virality,
              in stories that sit with you rather than scroll past you.
            </p>
            <p className="leading-relaxed">
              My work explores liminal spaces—the moments between, the places that exist
              in memory more vividly than in reality, the transformations that happen
              when we're not paying attention.
            </p>
            <p className="leading-relaxed">
              If my writing resonates with you, I'd love to hear about it. If it doesn't,
              that's okay too. Not every story is for every reader, and that's exactly
              as it should be.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;